import React from 'react';
import { Input } from '../../components/ui/input';

// Auto-formats US phone numbers as the user types or for display: 330-316-7136
export const formatPhoneNumber = (val) => {
  const raw = String(val || '');
  if (/^n\/?a$/i.test(raw.trim())) return raw;
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  digits = digits.slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const PhoneInput = ({ value, onChange, ...props }) => (
  <Input
    type="tel"
    inputMode="tel"
    value={value}
    onChange={(e) => onChange(formatPhoneNumber(e.target.value))}
    placeholder="330-316-7136"
    {...props}
  />
);
